import { motion } from "framer-motion";
import { EASE_HERO } from "@/lib/motion";

// Interior page hero: eyebrow + large serif title split into masked reveal lines.
const PageHero = ({ eyebrow, titleLines, intro, testId }) => {
  return (
    <section
      className="relative pt-28 lg:pt-36 pb-12 lg:pb-16 border-b border-border-subtle"
      data-testid={testId}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        {eyebrow && (
          <motion.div
            className="overline"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            {eyebrow}
          </motion.div>
        )}
        <h1 className="font-serif text-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight mt-6 max-w-4xl">
          {titleLines.map((line, i) => (
            <span className="reveal-line" key={i}>
              <motion.span
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.85, ease: EASE_HERO, delay: 0.15 + i * 0.11 }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>
        {intro && (
          <motion.p
            className="mt-8 max-w-2xl text-lg sm:text-xl font-light leading-relaxed text-charcoal/85"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE_HERO, delay: 0.15 + titleLines.length * 0.11 }}
          >
            {intro}
          </motion.p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
